import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Es material actualizado?',
  a: 'Sí, la jurisprudencia y los fundamentos legales están actualizados a la normativa y fallos vigentes. Además, al adquirirlo tenés acceso a futuras actualizaciones del documento.'
}, {
  q: '¿Cómo recibo el acceso?',
  a: 'Una vez acreditado el pago, recibirás automáticamente un correo electrónico con el enlace para descargar el material digital (PDF) en tu dispositivo.'
}, {
  q: '¿Sirve si recién empiezo en la profesión?',
  a: 'Absolutamente. Está diseñado para guiarte paso a paso. Los modelos y estrategias te darán la seguridad que necesitás para tomar tus primeros casos de salud sin miedo a equivocarte.'
}, {
  q: '¿Qué métodos de pago hay?',
  a: 'Podés abonar mediante Mercado Pago, tarjeta de crédito/débito o transferencia bancaria. Todo el proceso es 100% seguro.'
}, {
  q: '¿Hay garantía?',
  a: 'Sí, tenés 7 días de garantía de satisfacción. Si el material no cumple tus expectativas, te devolvemos el dinero.'
}];
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 bg-legal-800" data-id="element-83">
      <div className="container mx-auto px-4" data-id="element-84">
        <div className="text-center mb-12" data-id="element-85">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-86">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-4" data-id="element-87">
          {faqs.map((faq, idx) => <div key={idx} className="bg-legal-900 border border-legal-700 rounded-lg overflow-hidden" data-id="element-88">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none focus:ring-2 focus:ring-gold-500/50" data-id="element-89">
                <span className="text-lg font-medium text-white" data-id="element-90">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-gold-500 transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-91" />
              </button>
              <AnimatePresence data-id="element-92">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-93">
                    <div className="p-6 pt-0 text-slate-400 leading-relaxed border-t border-legal-800" data-id="element-94">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
};